import classNames from 'classnames';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { renderRoutes, RouteConfig } from 'react-router-config';
import { Dispatch } from 'redux';
import { getFirstManageSite } from '../../../lib';
import { ICommonSupportPageProps } from '../../../model';
import { SystemMenuId } from '../../../model/system/menu';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import styles from './index.module.scss';
export interface IProps {
  readonly route?: RouteConfig;
}
export const Notice = (props: ICommonSupportPageProps) => {
  const { site = getFirstManageSite() } = props;
  const pageType = location.pathname.split('/').reverse()[0];
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();

  useEffect(() => {
    menuDispatch({
      type: ReduxCommonActionType.SELECT_MENU_ID,
      result: SystemMenuId.BusinessNotice,
    });
  }, []);

  return (
    <div className={classNames(styles.page, styles[pageType])}>
      {renderRoutes(props.route?.routes, { site })}
    </div>
  );
};
